/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CnesDetailAliases {
  ACTION_PRINT = 'action-print',
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_CNES_DETAIL = 'contextual-bar-cnes-detail',
  FETCH_CNES_SEARCH_DETAIL = 'fetch-cnes-search-detail',
  FETCH_INCONSISTENCIES_CNES = 'fetch-inconsistencies-cnes',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_5 = 'field-5',
  FIELD_INCONSISTENCIES_CNES = 'field-inconsistencies-cnes',
  FIELD_STATUS = 'field-status',
  FORM_0 = 'form-0',
  LAYOUT_0 = 'layout-0',
  PANEL_1 = 'panel-1',
  PANEL_5 = 'panel-5',
  PANEL_CNES_INCONSISTENCIES = 'panel-cnes-inconsistencies',
  PANEL_CNES_SEARCH_DETAIL = 'panel-cnes-search-detail',
  PANEL_LEVEL = 'panel-level',
  PANEL_TITLE_CNES_INCONSISTENCIES = 'panel-title-cnes-inconsistencies',
  REPEATER = 'repeater',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_4 = 'text-4',
}
export { CnesDetailAliases };
